import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { ITransitionEvent } from '../transition/transition.types';
import { TButtonSize } from '../button/button.types';
import { TModalSize } from './modal.types';

@Component({
	selector: 'rbc-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnDestroy {
	@Input() active: boolean;
	@Input() buttonCancel: string = 'Cancel';
	@Input() buttonSize: TButtonSize = 'small';
	@Input() closable: boolean = true;
	@Input() disableBackgroundClick: boolean;
	@Input() height: number;
	@Input() id: string;
	@Input() labelCloseButton: string = 'Close';
	@Input() scrollable: boolean;
	@Input() size: TModalSize = 'small';
	@Input() title: string;
	@Input() showButton: boolean = true;

	@Output() toggle = new EventEmitter();

	insideCard: boolean = false;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	classGen() {
		return {
			'modal-scrollable': this.scrollable,
			[`modal-${this.size}`]: this.size
		};
	}

	ModalToggle(e) {
		this.toggle.emit(e);
		this.active = false;
	}

	Modal_toggleOnBackground(e) {
		this.insideCard = !e.target.classList.contains('modal');
		if (!this.disableBackgroundClick && !this.insideCard) {
			this.active = false;
			this.toggle.emit(e);
		}
	}

	transitionHook(animationEvent: ITransitionEvent) {
		if (animationEvent.type === 'enter') {
			document.getElementById(this.id).classList.remove('opacity-leave-hook');
			document.getElementById(this.id).classList.add('opacity-enter-hook');
		} else if (animationEvent.type === 'leave') {
			document.getElementById(this.id).classList.remove('opacity-enter-hook');
			document.getElementById(this.id).classList.add('opacity-leave-hook');
		}
	}

	// Manual open/close methods
	open() {
		this.active = true;
	}

	close() {
		this.active = false;
	}
}
